// src/components/GoogleSignInButton.js

import React, { useContext, useEffect } from 'react';
import { initializeGoogleSignIn, renderGoogleButton } from '../../services/AuthService';
import { AuthContext } from '../../contexts/AuthContext';

function GoogleSignInButton() {
  const { setIsAuthenticated, setUser } = useContext(AuthContext);

  useEffect(() => {
    initializeGoogleSignIn((user) => {
      try {
        // Instead of storing tokens, just update context
        setIsAuthenticated(true);
        setUser(user);
      } catch (error) {
        console.error('Error setting user from Google sign-in:', error);
      }
    });
    renderGoogleButton();
  }, [setIsAuthenticated, setUser]);

  return <div id="google-signin-button"></div>;
}

export default GoogleSignInButton;